import { useState } from 'preact/hooks'
import { BackgroundPicker } from './components/BackgroundPicker'
import { CornerPicker } from './components/CornerPicker'
import { EmojiPicker } from './components/EmojiPicker'
import { ExportPanel } from './components/ExportPanel'
import { ImageUploader } from './components/ImageUploader'
import { InfoLinks } from './components/InfoLinks'
import { InnerFramePicker } from './components/InnerFramePicker'
import { Preview } from './components/Preview'
import { DEFAULT_CONFIG } from './constants'
import type { IconConfig } from './types'

export function App() {
  const [config, setConfig] = useState<IconConfig>(DEFAULT_CONFIG)

  const update = <Key extends keyof IconConfig>(key: Key, value: IconConfig[Key]) => {
    setConfig((current) => ({ ...current, [key]: value }))
  }

  return (
    <div class="layout">
      <aside class="sidebar">
        <div class="sidebar-scroll">
          <h1 class="title">Harbour Icon Builder</h1>
          <p class="subtitle">Design Sailfish OS app icons in your browser.</p>
          <CornerPicker value={config.corners} onChange={(corners) => update('corners', corners)} />
          <BackgroundPicker value={config.background} onChange={(background) => update('background', background)} />
          <InnerFramePicker value={config.innerFrame} onChange={(innerFrame) => update('innerFrame', innerFrame)} />
          <ImageUploader value={config.contents} onChange={(contents) => update('contents', contents)} />
          <EmojiPicker
            value={config.contents}
            onChange={(contents) => update('contents', contents)}
            useTwemoji={config.useTwemoji}
            onTwemojiChange={(useTwemoji) => update('useTwemoji', useTwemoji)}
          />
        </div>
        <footer class="sidebar-footer">
          <InfoLinks />
        </footer>
      </aside>
      <main class="main">
        <ExportPanel config={config} onAppName={(name) => update('appName', name)} />
        <Preview config={config} onContentsChange={(contents) => update('contents', contents)} />
      </main>
    </div>
  )
}
